import { useGetApprovalItem } from 'pages/approvals/hooks/useGetApprovalItem';
import { useGetApprovalParticipation } from 'pages/approvals/hooks/useGetApprovalParticipation';
import { useGetApprovalSnapshot } from 'pages/approvals/hooks/useGetApprovalSnapshot';
import { ApprovalItemModal } from 'pages/approvals/modals/ApprovalItemModal';
import { idToUri } from 'pages/global/UriHelper';
import { StringParam, useQueryParam } from 'use-query-params';

/**
 * Modal for displaying approval participation details
 */
export function ApprovalParticipationModalListener() {
    const [approvalParticipationId, setApprovalParticipationId] = useQueryParam('ap', StringParam);
    const participation = useGetApprovalParticipation(
        approvalParticipationId ? idToUri(approvalParticipationId, 'ApprovalParticipation') : undefined,
    );
    const approvalItem = useGetApprovalItem(participation?.approvalItem);
    const snapshot = useGetApprovalSnapshot(participation?.snapshot);

    return (
        <ApprovalItemModal
            approvalItemId={approvalItem?.id}
            approvalParticipationId={approvalParticipationId}
            show={!!approvalParticipationId}
            close={close}
            snapshot={snapshot}
        />
    );

    /**
     * @returns {void}
     */
    function close() {
        setApprovalParticipationId(undefined);
    }
}
